import { useEffect, useRef } from "react";
import Slider from "react-slick";

import { Box, SVGSprite } from "@/components/Atoms";
import { useAppDispatch, useAppSelector } from "@/hooks";

import * as actions from "@/redux/ShyftPassReducer";

import styles from "./DateCarousel.module.scss";

const DateCarousel = ({ selectedDate, eventDates }) => {
  const dispatch = useAppDispatch();

  const { selectedShyftPassZoneId, isLoading } = useAppSelector(
    (state) => state.shyftPass
  );

  const setSelectedDate = (date) => {
    if (selectedDate === date) {
      return;
    }
    dispatch(actions.setSelectedDate(date));
    dispatch(
      actions.getShyftPassScheduleData({
        startDate: date,
        zoneId: selectedShyftPassZoneId,
      })
    );
  };

  const slider = useRef();
  // slider?.current?.slickGoTo(index);

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          centerMode: true,
        },
      },
    ],
    prevArrow: (
      <Box>
        <Box>
          <SVGSprite icon="icon-slider-arrow-left" height="24px" width="24px" />
        </Box>
      </Box>
    ),
    nextArrow: (
      <Box>
        <Box>
          <SVGSprite
            icon="icon-slider-arrow-right"
            height="24px"
            width="24px"
          />
        </Box>
      </Box>
    ),
    afterChange: (current) => {
      const isMobileDevice = slider?.current?.state?.breakpoint === 767;
      const nextDate = eventDates?.[current]?.date;
      if (isMobileDevice) setSelectedDate(nextDate);
    },
  };

  useEffect(() => {
    const matchedIndex = eventDates?.findIndex(
      (item: any) => selectedDate === item?.date
    );
    const isMobileDevice = slider?.current?.state?.breakpoint <= 767;
    if (matchedIndex >= 0 && !isLoading && isMobileDevice) {
      slider?.current?.slickGoTo(matchedIndex);
    }
  });

  return (
    <div className={styles.dateCarousel}>
      <div>
        <Slider {...settings} ref={slider}>
          {eventDates?.map(({ date, title }, index) => {
            return (
              <div
                key={index}
                className={[
                  styles.dateChip,
                  selectedDate === date ? styles.active : "",
                ].join(" ")}
                onClick={() => {
                  setSelectedDate(date);
                }}
              >
                <div>
                  <span>{title}</span>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default DateCarousel;
